<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Overzicht</p>
      </sidebar-link>
      <sidebar-link to="/admin/settings">
        <i class="nc-icon nc-settings-90"></i>
        <p>Intellingen</p>
      </sidebar-link>
      <sidebar-link to="/admin/audit">
        <i class="nc-icon nc-lock-circle-open"></i>
        <p>Audit</p>
      </sidebar-link>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  import axios from 'axios'
  export default {
    components: {
      TopNavbar,
      DashboardContent,
      MobileMenu
    },
    data() {
      return {
        user: {
          name: "not-set"
        }
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      getUserData: function() {
        let self = this
        axios.get("/api/user")
          .then((response) => {
            console.log(response)
            self.$set(this, "user", response.data.user)
          })
          .catch((errors) => {
            console.log(errors)
            this.$router.push("/")
          })
      }
    },
    mounted() {
      this.getUserData()
    }
  }

</script>
